import { __awaiter, __generator } from "tslib";
import { paginationKey } from '.';
export var createPaginationDriver = function (wrapper) {
    var base = wrapper.$("." + paginationKey);
    return {
        getVisiblePages: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$$('.page').text()];
        }); }); },
        getSelected: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.page.current').text()];
        }); }); },
        selectedPage: function (page) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, base.$(".page.page-" + page).click()];
            });
        }); },
        prevArrowExists: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.prev-page').exists()];
        }); }); },
        nextArrowExists: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.next-page').exists()];
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map